<div mat-dialog-title class="toolbar toolbar-row">
    <span>{{'REGISTRATION.WATCH_DIALOG.TITLE' | translate}}</span>
</div>
<div mat-dialog-content>
    <p>{{'REGISTRATION.WATCH_DIALOG.SUBTITLE' | translate}}</p>
    <mat-form-field class="full-width">
        <mat-label>{{'REGISTRATION.WATCH_DIALOG.WATCHBAND_SIZE' | translate}}</mat-label>
        <mat-select name="app-watchband-size-select" [(ngModel)]="data.watchBandSize">
            <mat-option *ngFor="let value of getList()" [value]="value">
                {{value}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button name="app-watchband-size-button" class="mat-raised-button mat-primary pull-right"
        [mat-dialog-close]="data.watchBandSize" cdkFocusInitial>{{'COMMON.CONFIRM' | translate}}</button>
</div>
